var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResponsiveGroup3Ic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 265,
    height: 270,
    viewBox: "0 0 265 270",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 8.45369,
    y: 89.5953,
    width: 105.33,
    height: 266.85,
    rx: 52.665,
    transform: "rotate(-49.9455 8.45369 89.5953)",
    stroke: "url(#paint0_linear_1043_89169)",
    strokeWidth: 12
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1043_89169",
    x1: 58.665,
    y1: 90.3268,
    x2: 58.665,
    y2: 369.177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCCEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#98B6F5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResponsiveGroup3Ic);
export default __webpack_public_path__ + "static/media/responsiveGroup3_ic.12a27bb0.svg";
export { ForwardRef as ReactComponent };